import axios from 'axios'
import { bffBaseURL, normalizeError } from './apiClient'

// ============================================================================
// User Management API — Admin Only
// ============================================================================

export interface GetUsersOptions {
  /**
   * Phase 100 Task 3.2: Filter users to those whose roles grant access to
   * a specific app. E.g. `{ app_access: 'cantera' }` returns only recruiters
   * eligible to be assigned to Cantera positions. The filter is resolved
   * server-side via the role_app_access matrix in auth-service.
   */
  app_access?: string
}

export async function getUsers(options: GetUsersOptions = {}) {
  try {
    const response = await axios.get(
      `${bffBaseURL}/api/admin/users`,
      {
        params: options.app_access ? { app_access: options.app_access } : undefined,
      }
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = (error.response?.data as any)?.message || 'Error cargando usuarios'
      throw new Error(message)
    }
    throw error
  }
}

export async function createUser(userData: any) {
  try {
    // Phase 76 M5: Pre-flight validation removed. BFF gate("users") enforces access.
    const response = await axios.post(
      `${bffBaseURL}/api/admin/users`,
      userData,
      {
        headers: {
          'X-Admin-Operation': 'user-create'
        }
      }
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = (error.response?.data as any)?.message || 'Error creando usuario'
      throw new Error(message)
    }
    throw error
  }
}

// Phase 97b BUG-007: Deleted dead updateUserRole() — singular role interface,
// never imported by any component. Role updates go through UserManagementContext.updateUserRoles().

export async function deleteUser(userId: string) {
  try {
    // Phase 76 M5: Pre-flight validation removed. BFF gate("users") enforces access.
    const response = await axios.delete(
      `${bffBaseURL}/api/admin/users/${userId}`,
      {
        headers: {
          'X-Admin-Operation': 'user-delete'
        }
      }
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = (error.response?.data as any)?.message || 'Error eliminando usuario'
      throw new Error(message)
    }
    throw error
  }
}

export async function resetUserPassword(userId: string) {
  try {
    // Phase 76 M5: Pre-flight validation removed. BFF gate("users") enforces access.
    const response = await axios.post(
      `${bffBaseURL}/api/admin/users/${userId}/reset-password`,
      {},
      {
        headers: {
          'X-Admin-Operation': 'user-password-reset'
        }
      }
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = (error.response?.data as any)?.message || 'Error restableciendo contraseña'
      throw new Error(message)
    }
    throw error
  }
}

export async function getUserById(userId: string) {
  try {
    const response = await axios.get(
      `${bffBaseURL}/api/admin/users/${userId}`
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = (error.response?.data as any)?.message || 'Error obteniendo usuario'
      throw new Error(message)
    }
    throw error
  }
}
